import { useCallback } from "react";
import { RoutesInterface } from "./../services/api-routes";
import { apiRequest } from "./../services/api-instance";
import apiRoutes from "./../services/api-routes";

type Hook = {
  downloadCSV: (API: string, reportName: string, reportType: string, payload: any) => any;
};

const useCSV = (): Hook => {
  const downloadCSV = useCallback(
    async (API: string, reportName: string, reportType: string, payload: any) => {
      const [error, data] = await apiRequest({
        method: "post",
        url: `${API}`,
        data: payload
      });
      if (data) {
        const str = window.atob(data);
        let download = document.createElement("a");
        download.textContent = "download";
        download.download =
          reportName + '-' + new Date().toISOString() + "." + reportType;
        download.href = "data:text/csv;charset=utf-8," + escape(str);
        download.click();
      } else {
        console.log("err", error);
      }
      return [error, data]
    },
    []
  );

  return {
    downloadCSV,
  };
};

export default useCSV;
